import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'

const Icon = () => {
  return (
    <ArrowUpwardIcon
      htmlColor='rgba(0, 0, 0, 0.54)'
      fontSize='medium'
    />
  )
}

export default Icon
